import React from "react";

//UI Material
import { TableCell, TableRow, Typography } from "@mui/material";

export default function ItemCategoryRow({ category }) {
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{category.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{category.name}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{category.description}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{category.prefix}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{category.itemsRegistered}</Typography>
      </TableCell>
    </TableRow>
  );
}
